import { AnyAction } from 'redux';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from '../../redux/root';

const useThunkDispatch = () => useDispatch<ThunkDispatch<Store, void, AnyAction>>();

export default useThunkDispatch;
